<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <span class="select-title">案件ID：</span>
        <el-input
          v-model="caseId"
          placeholder="请输入事件ID"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">受助人姓名：</span>
        <el-input
          v-model="recName"
          placeholder="受助人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>

      <li>
        <span class="select-title">受助人身份证号：</span>
        <el-input
          v-model="recIdNo"
          maxlength="18"
          placeholder="受助人身份证号"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">邮件发送时间：</span>
        <el-date-picker
          v-model="sendTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </li>

      <li>
        <span class="select-title">状态：</span>
        <el-cascader
          v-model="sendStatus"
          :options="sendStatusList"
          :props="sendStatusProps"
          class="select-input"
          clearable
          @change="sendStatusChange"
        />
      </li>

      <li>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </li>
      <li />
      <li style="display: block; width: 100%">
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="seecase">
          查看案件详情
        </el-button>
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="seeemail">
          查看邮件内容
        </el-button>
      </li>
    </ul>
    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />

      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="案件id" prop="caseId" />
      <el-table-column width="180" prop="reportTime" label="报案时间" />
      <el-table-column
        width="180"
        prop="productName"
        label="计划类型"
        show-overflow-tooltip
      />
      <el-table-column prop="applicationName" label="收件人" width="100" />
      <el-table-column prop="applicationMail" label="收件邮箱" show-overflow-tooltip />
      <el-table-column prop="mailTypeName" label="邮件类型" show-overflow-tooltip />
      <el-table-column width="180" prop="sendTime" label="邮件发送时间" />
      <el-table-column prop="sendStatus" label="发送状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sendStatus == '0'" type="">未发送</el-tag>
          <el-tag v-else-if="scope.row.sendStatus == '1'" type="warning">未送达</el-tag>
          <el-tag v-else-if="scope.row.sendStatus == '2'" type="success">已发送</el-tag>
          <el-tag v-else-if="scope.row.sendStatus == '3'" type="danger">发送失败</el-tag>
          <el-tag v-else-if="scope.row.sendStatus == '4'" type="info">已取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            v-if="
              scope.row.sendStatus == '0' && checkPermission('取消定时发邮件', permList)
            "
            icon="iconfont icon-biangeng"
            type="text"
            size="small"
            @click="cancel(scope.row.id)"
          >
            取消定时发送
          </el-button>
          <el-button
            v-if="checkPermission('邮件列表:邮件重新发送', permList)"
            icon="iconfont icon-biangeng"
            type="text"
            size="small"
            @click="repeatEmail(scope.row.id)"
          >
            重新发送
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>

    <!-- ===============邮件组件============== -->
    <router-view
      :showdrawer="showdrawer"
      drawer-type="email"
      :remark="remark"
      @closedrawer="closedrawer"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },

      loading: true,
      limit: 10,
      pageIndex: 1,
      caseId: '',
      sendStatus: null,
      sendTime: '',
      recName: '',
      recIdNo: '',

      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },
      tableData: {},
      selectRows: [],
      currentCode: '',
      formLabelWidth: '120px',
      sendStatusList: [
        {
          code: '0',
          name: '未发送'
        },
        {
          code: '1',
          name: '未送达'
        },
        {
          code: '2',
          name: '已发送'
        },
        {
          code: '3',
          name: '发送失败'
        },
        {
          code: '4',
          name: '已取消'
        }
      ],

      sendStatusProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },

      showdrawer: false,
      drawerType: '',
      remark: ''
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '定时邮件列表')
    const currentmyEmailSearchData = JSON.parse(
      localStorage.getItem('currentmyEmailSearchData')
    )
    if (currentmyEmailSearchData) {
      (this.limit = currentmyEmailSearchData.limit),
      (this.pageIndex = currentmyEmailSearchData.pageIndex),
      (this.caseId = currentmyEmailSearchData.caseId),
      (this.sendStatus = currentmyEmailSearchData.sendStatus),
      (this.sendTime = currentmyEmailSearchData.sendTime),
      (this.recName = currentmyEmailSearchData.recName),
      (this.recIdNo = currentmyEmailSearchData.recIdNo)
    }
    this.getEmailList(
      this.limit,
      this.pageIndex,
      this.caseId,
      this.sendStatus,
      this.sendTime,
      this.recName,
      this.recIdNo
    )
  },

  methods: {
    repeatEmail(id) {
      this.axios
        .put(this.homePath() + '/casesCommon/repeatEmail?id=' + id)
        .then((res) => {
          if (res.data.status === '000000') {
            this.$alert('发送成功', '提示')
            this.getEmailList(
              this.limit,
              this.pageIndex,
              this.caseId,
              this.sendStatus,
              this.sendTime,
              this.recName,
              this.recIdNo
            )
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    sendStatusChange(val) {
      this.sendStatus = val
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 邮件列表
     */
    getEmailList(limit, page, caseId, sendStatus, sendTime, recName, recIdNo) {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/casesCommon/getMailTimerList', {
          params: {
            limit: limit,
            page: page,
            caseId: caseId,
            sendStatus: sendStatus,
            sendTime: sendTime,
            recIdNo: recIdNo,
            recName: recName
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.loading = false
            vm.tableData = data.page
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.pageIndex = 1
      this.getEmailList(
        this.limit,
        this.pageIndex,
        this.caseId,
        this.sendStatus,
        this.sendTime,
        this.recName,
        this.recIdNo
      )
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },
    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },
    selectionChange(rows) {
      this.selectRows = rows
    },

    changeOperator(val) {
      this.currentCode = val.code
    },

    seecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      const currentmyEmailSearchData = {
        limit: vm.limit,
        pageIndex: vm.pageIndex,
        caseId: vm.caseId,
        sendStatus: vm.sendStatus,
        sendTime: vm.sendTime,
        recName: vm.recName,
        recIdNo: vm.recIdNo
      }
      localStorage.setItem(
        'currentmyEmailSearchData',
        JSON.stringify(currentmyEmailSearchData)
      )
      this.$router.push({
        path: '/index/caseDetailV2/' + vm.selectRows[0].caseCode,
        query: {
          from: 'myemail'
        }
      })
    },

    seeemail() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      vm.axios
        .get(vm.homePath() + '/casesCommon/getSendMailMsgById', {
          params: {
            id: vm.selectRows[0].id
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status == '000000') {
            vm.showdrawer = true
            vm.remark = data.result
            vm.drawerType = 'email'
          } else {
            this.$alert(data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    closedrawer(close) {
      this.showdrawer = close
    },

    pageChange(val) {
      this.pageIndex = val
      this.getEmailList(
        this.limit,
        this.pageIndex,
        this.caseId,
        this.sendStatus,
        this.sendTime,
        this.recName,
        this.recIdNo
      )
    },

    cancel(id) {
      const vm = this
      vm.$confirm('确定要操作取消定时发送邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async() => {
          setTimeout(function() {
            vm.cancelEmail(id)
          }, 100)
        })
        .catch(() => {
          console.log('取消发送')
        })
    },

    cancelEmail(id) {
      const vm = this
      vm.axios({
        url: vm.homePath() + '/casesCommon/cancleTimerMail?id=' + id,
        method: 'put',
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const data = res.data
          if (data.status == '000000') {
            vm.getEmailList(
              vm.limit,
              vm.pageIndex,
              vm.caseId,
              vm.sendStatus,
              vm.sendTime,
              vm.recName,
              vm.recIdNo
            )
          } else {
            vm.$alert(data.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
.el-drawer__close-btn {
  float: right;
  outline: none;
}

.el-drawer__header {
  display: block;
}
</style>
